var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.appBlockContainerWithTag
  }, [_c('AppBlock', {
    class: _vm.$style.appBlock,
    attrs: {
      "name": _vm.app.appName,
      "description": _vm.app.description,
      "category": _vm.app.category,
      "card-image": _vm.app.cardImage,
      "card-image-mobile": _vm.app.cardImageMobile,
      "app-url": _vm.app.appUrl,
      "app-id": _vm.app.appId,
      "is-new-app": _vm.app.isNewApp,
      "options": {
        forceMobileDesign: true
      }
    }
  }), _c('AppTag', {
    class: _vm.$style.appTag,
    attrs: {
      "app": _vm.app,
      "category": _vm.app.category
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }